import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { formatDate } from "utils/Utils";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { lendingPartnerDeal } from "assets/properties/properties";
const PartnerDeal = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deletePartnerId, setPartnerId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  // get api calling
  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PARTNER_LENDING_FIND_DEALS + params?.code,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };

  // parseindicatordata function
  const parseIndicatorData = (data) => {
    let reportData = [];
    data &&
      data?.forEach((role, index) => {
        let row = {
          code: role.code,
          partnerCode: role.partnerCode,
          name: role.name,
          type:role?.productType,
          status: role.active === true ? "Yes" : "No",
          action: getIcons(role.id),
          viewCode: role?.code,
          makeClickable: role?.active,
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };

  // icons function
  const getIcons = (role) => {
    return (
      <>
        <IconButton
          aria-label="Edit Role"
          onClick={(e) => {
            e.stopPropagation(); // 👈 Prevent row click
            onClickUpdateData(role);
          }}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete Role"
          onClick={(e) => {
            e.stopPropagation(); // 👈 Prevent row click
            onClickDeleteData(role);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  // update function
  const onClickUpdateData = (role) => {
    navigate(`/coreservice/partnerDeal-create/${role}/${params?.code}/${params?.name}/${params?.id}`);
  };
  const onClickAddDealData = (code, name, id) => {
    navigate(`/coreservice/partnerDealShare/${code}`);
  };
  // delete function
  const onClickDeleteData = (role) => {
    setConfirmationModalHeader(lendingPartnerDeal?.confirmationHdr);
    setConfirmationModalMsg(lendingPartnerDeal?.confirmationMsg);
    setPartnerId(role);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setPartnerId("");
  };
  const handlePositiveResponse = async () => {
    const partnerId = deletePartnerId;
    handleNegativeResponse();
    setCallInProgress(true);
    // Call API to delete Role
    const res = await apiHandler({
      url: endpoint.PARTNER_DEAL_DELETE + partnerId,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", lendingPartnerDeal?.deleteMessage, true);
      GetData();
    }
  };

  // serach function
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        row.name?.toLowerCase()?.includes(val?.toLowerCase()),
        row.code?.toLowerCase()?.includes(val?.toLowerCase())
      );
    });
    parseIndicatorData(filteredData);
  };
  const handleCreateOrnament = () => {
    navigate(`/coreservice/partnerDeal-create/${params?.code}/${params?.name}/${params?.id}`);
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <SubHeader
            label={lendingPartnerDeal?.label}
            button1={lendingPartnerDeal?.buttonCreate}
            button1click={handleCreateOrnament}
            onSearchChange={onSearchChange}
            searchLabel={lendingPartnerDeal?.searchLabel}
            search
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <ColumnGroupingTable
            columns={lendingPartnerDeal?.tableColumns}
            rows={selectedTableData}
            onClickViewData={onClickAddDealData}
            clickable
          />
        </GridItem>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
        />
      </GridContainer>
    </>
  );
};

export default PartnerDeal;
